import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const TotalPastDues = ({ qa }) => {
  const { displayPastDues, totalPastDues, totalPastDuesLink } = useSelector(
    (state) => state.membershipUnits.membershipUnits.totalPastDues
  );

  return displayPastDues ? (
    <div className="content__el">
      <DataDisplay
        label="Total Past Dues"
        type="number"
        value={totalPastDues}
        url={totalPastDuesLink}
        disableAnimation={qa}
      />
    </div>
  ) : null;
};

export default TotalPastDues;
